let S_CONTINUE = `Do you want to continue?`;
let S_CONFIRMATION = `Confirmation`;
let S_CONFIRM_EXIT_DATA_LOST = `Are you sure you want to exit? All details entered will be lost.`;
let S_SUCCESS = `Success!`;
let S_UPLOAD_CANCELLED = `Upload has been Cancelled`;
let S_UPLOAD_ABORTED = `Upload has been aborted`;
let S_UPLOAD_RECORDS_SUCCESS = `All records has been uploaded successfully.`;
let S_SOMETHING_WENT_WRONG = `Something went wrong. Please try again.`;
let S_GENERATE_MODAL_BILLING = `Are you sure you want to generate a Modal Billing for the selected Cutoff?`;
let S_DISCLAIMER_AGREE = `Please read and agree with the above disclaimer.`;
let S_ANY_CHANGES_WONT_AFFECT = `Please take note that any changes that will made on this document will not affect the original content of the MAS record.`;

let S_CONFIRM_UPLOAD = function (sFileName = '') { return `You are about to upload ${sFileName}`; };
let S_GENERATE_INITIAL_BILLING = function (sCompanyName = '') { return `Are you sure you want to create Initial billing for ${sCompanyName} ?`; };
let S_GENERATE_MISC_BILLING = function (sCompanyName = '') { return `Are you sure you want to create Miscellaneous billing for ${sCompanyName} ?`; };
let S_POST_ADJUSTMNET_BILLING = function (sCompanyName = '') { return `Are you sure you want to post Adjustment for ${sCompanyName}?`; };
let S_UPLOAD_FAILED_ROWS = function (iFailedRowCount = 0, iTotalRowCount = 0) { return `${iFailedRowCount} / ${iTotalRowCount} records failed.`; };
let S_UPLOAD_DESCREPANCY_ROWS = function (iFailedRowCount = 0, iTotalRowCount = 0) { return `${iFailedRowCount} / ${iTotalRowCount} records failed.`; };

let S_KEEN_DATATABLE_ERROR = function (objJqXhr = { status: '', statusText: '' }) { return `An error has been reported by KDataTables: ${objJqXhr.status} ${objJqXhr.statusText}.`; };
let S_JQUERY_DATATABLE_ERROR = function (sErrMsg = '') { return `An error has been reported by DataTables: ${sErrMsg}.`; };

// Benefit Template / Plan Labels
let S_ALLOWED_SERVICES_ONLY = `Selected applicable service are greater than the covered services from the benefit plan, attempt to add/change applicable services is denied.`;
let S_ALLOWED_MEMBERS_ONLY = `Selected member types are greater than the benefit plan's member types. Attempt to add/change member type is denied.`;

let S_CONFIRM_SAVE_FEE = `Are you sure you want to save this fee?`;
let S_SAVE_FEE_SUCCESS = `Your fee has been saved.`;

let S_CONFIRM_SAVE_PROVIDER_ACCESS = `Are you sure you want to save this provider access?`;
let S_SAVE_PROVIDER_ACCESS_SUCCESS = function (sSaveType = '') { return sSaveType === 'CREATE' ? `Sucessfully added Provider to the list.` : `Sucessfully updated the Provider Access.` };
let S_ALLOWED_PROVIDERS_ONLY = `The system detected that this plan already have Allowed Providers, adding restricted providers will not be allowed.`;
let S_RESTRICTED_PROVIDERS_ONLY = `The system detected that this plan already have Restricted Providers, adding allowed providers will not be allowed.`;

let S_APPROVE_CONTRACT_SETUP_SUCCESS = `The Selected Contract Setup has been successfully Approved.`;
let S_RETRIEVE_APPROVAL_CONTRACT_SETUP_SUCCESS = `The Selected Contract Setup has been Retrieved for Approval Successfully.`;
let S_FLAG_TEMPLATE_AND_PLAN_AS_APPROVED_SUCCESS = function (sPlanName = '') { return `${sPlanName} is now tagged as Approved.`; };
let S_FLAG_PLAN_AS_REVIEWED_SUCCESS = function (sPlanName = '') { return `${sPlanName} is now tagged as Reviewed.`; };

let S_CONFIRM_SAVE_TEMPLATE_AND_PLAN = function (sSaveType = '') { return sSaveType === 'CREATE' ? `Are you sure you want to create this Benefit Plan?` : sSaveType === 'UPDATE' ? `Are you sure you want to update this Benefit Plan?` : `Are you sure you want to amend this Benefit Plan?`; };
let S_CONFIRM_SAVE_TEMPLATE_AND_PLAN_SUCCESS = function (sTemplateType = '') { return sTemplateType === 'PER_COMPANY' ? `Successfully saved Benefit Plan.` : `Your benefit plan template has been saved!`; };
let S_CONFIRM_SAVE_RETAIL_TEMPLATE = `Are you sure you want to save this benefit plan template?`;
let S_CONFIRM_UPDATE_RETAIL_TEMPLATE = `Are you sure to save changes on this benefit plan template?`;
let S_CONFIRM_SAVE_RETAIL_TEMPLATE_SUCCESS = `Your benefit plan template has been saved!`;

let S_CONFIRM_RECREATE_LIMITS = `Are you sure you want to recreate these limits?`;
let S_RECREATE_LIMITS_SUCCESS = `Limits successfully recreated!`;

let S_CONFIRM_SAVE_SA_INNER_LIMITS = `Are you sure you want to save these SA inner limits?`;
let S_SAVE_SA_INNER_LIMITS_SUCCESS = `Your selected SA inner limits has been successfully saved.`;

let S_CONFIRM_SAVE_INNER_LIMIT = `Are you sure you want to save this inner limit?`;
let S_SAVE_INNER_LIMIT_SUCCESS = `Your inner limit setup has been saved successfully.`;

let S_CONFIRM_SAVE_OUTER_LIMIT = `Are you sure you want to save these outer limits?`;
let S_SAVE_OUTER_LIMIT_SUCCESS = `Your outer limits has been updated!`;
// Benefit Template / Plan Labels

// Quick Search Labels
let S_QUICK_SEARCH_CHAR_LIMIT = `For optimized search results, please enter at least 4 characters on your search query.`;
// Quick Search Labels

// Telemedicine Movement Labels
let S_CONFIRM_GENERATE_MOVEMENT = `Are you sure you want to generate telemedicine movement?`;
let S_GENERATE_MOVEMENT_SUCCESS = `Telemedicine movement succesfully generated.`;
// Telemedicine Movement Labels

// WebKit Amendment Labels
let S_CONFIRM_SAVE_SPECIFY_BATCH_NO = `Are you sure you want to specify this batch number?`;
let S_CONFIRM_SAVE_SPECIFY_BATCH_NO_SUCCESS = `The batch number was successfully specified.`;
// WebKit Amendment Labels

// Payment Settings Labels
let S_CONFIRM_SAVE_TOLERANCE_SETTINGS = `Are you sure you want to save this tolerance settings?`;
let S_CONFIRM_SAVE_TOLERANCE_SETTINGS_SUCCESS = `The tolerance settings was successfully saved.`;

let S_CONFIRM_SAVE_AMOUNT_REASON = `Are you sure you want to save this amount reason?`;
let S_CONFIRM_SAVE_AMOUNT_REASON_SUCCESS = `The amount reason was successfully saved.`;

let S_CONFIRM_SAVE_ADJUSTMENT_REASON = `Are you sure you want to save this adjustment reason?`;
let S_CONFIRM_SAVE_ADJUSTMENT_SUCCESS = `The adjustment reason was successfully saved.`;
// Payment Settings Labels